import {PageTransformFn} from '@/src/core/domain/page/functions/types'

export const videoTransform: PageTransformFn = async function (data) {
  data.breadcrumbs.unshift({
    title: 'Видеообзоры',
  })

  return data
}
